import { Service } from '../../class/service';
import { Cookies } from '../../class/cookies';
import { Filter } from '../../class/filter';

export class View {
    //Mostrar loader
    protected state: boolean = false;
    //Mostrar vista del formulario
	protected list: boolean = true;
    //Niveles del usuario
	protected privileges: Object = {};
    //Accion de guardar y modificar
	protected action: String = "";
    //Id del usuario logueado
	protected myId: number = 0;
    //Variables para mostrar mensajes
	protected active: boolean = false;
	protected message: string = "";
	protected type: string = "";	/*success - danger */
    //Paginacion y mostrar las paginas
	protected pagination: Array<any>;
	protected pages: Array<number> = [];
    protected _serviceName:string;
    protected serviceNmae(_serviceName:string){
        this._serviceName = _serviceName;
    }
	protected __filter:Filter;
	protected toSearch(event:any){
		this.extra["search"] = event;
		this.getList(1,event);
	}

	protected filter(_filter:Filter){
		this.__filter = _filter;
	}
	protected extra:Object = {
        search: ''
    };

    constructor(protected service: Service, protected cookies: Cookies, protected viewName:string){
        //Obtener el usuario loguedo
		this.myId = this.cookies.getCookie('ChamUserObject')["userprofile"][0]["id"];
		//Validar privilegios
		this.service.PRIVILEGES(this.myId, this.viewName).subscribe(res => {
			this.privileges = res["privileges"][0];
			if (this.privileges["read"] == 1) {
				this.getList(1, "");
			} else if (this.privileges["create"] == 1) {
				this.list = false;
				this.action = "Guardar";
				this.state = !this.state;
			}
		}, err => { console.log(err); });
	}

    //Para mostrar mensajes
	protected openMd(_msg: string, _type: string): void {
		this.active = true;
		this.message = _msg;
		this.type = _type;
		setTimeout(() => {
			this.active = false;
		}, 4000);
	}
    //Cargar los egistros anteriores paginados.
	protected getList(page: number, search: string): void {
		this.state = !this.state;
		this.service.GET(this._serviceName, "&page=" + page + search).subscribe(res => {
			this.pagination = res["data"];
			this.pages = [];
			var it = 1;
			var limit = 10;
			var ex = 0;
			for (var _i = 1; _i <= limit; _i++) {
				ex++;
				var num = _i;
				if (this.pagination["current_page"] > 6) {
					num += this.pagination["current_page"] - 6;
				}
				if (num > this.pagination["last_page"]) {
					ex = ex - limit - 1;
					break;
				}
			}
			for (var _i = 1; _i <= limit; _i++) {
				var num = _i;
				if (ex < 0) {
					num = num + ex;
				}

				if (this.pagination["current_page"] > 6) {
					num += this.pagination["current_page"] - 6;
				}
				if (num > this.pagination["last_page"]) {
					break;
				}
				if (num > 0) {
					this.pages.push(num);
				}
			}
			this.state = !this.state;
		}, err => {
			console.log(err);
			this.state = !this.state;
		});
	}
	//LLevar al numero solicitado
	protected getPageNumber(url: String) {
		let p = url.split('page=')[1];
		return parseInt(p, 10);
	}
}



// WEBPACK FOOTER //
// ./src/app/component/module/view.ts